import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  phoneLabel: {
    defaultMessage: 'Phone Number',
    id: 'Wnk7SI',
    description: 'otherShippingOptions.phoneNumber',
  },
  phoneSublabel: {
    defaultMessage: 'Phone number is populated from the order',
    id: 't4XInX',
    description: 'phone number notification option sublabel',
  },
  emailLabel: {
    defaultMessage: 'Email Message',
    id: 'M7OVow',
    description: 'otherShippingOptions.emailAddress',
  },
  emailSublabel: {
    defaultMessage: 'Email address is populated from the order',
    id: 'ypglEi',
    description: 'email address notification option sublabel',
  },
  shipperLoadAndCountNumber: {
    defaultMessage: 'Shipper Load and Count #',
    description: 'Other shipping options shipper load and count number',
    id: 'FZRieD',
  },
  bookingLabel: {
    defaultMessage: 'Booking Confirmation #',
    description: 'Other shipping options booking confirmation number',
    id: 'UsXPnh',
  },
  billToSenderTooltip: {
    description: 'Tooltip for bill duties and taxes to payor of shipping charges',
    defaultMessage:
      'When International Settings > Duties & Taxes is enabled, this label option is automatically checked for all UPS, FedEx, and DHL Express shipments.',
    id: 'IW566H',
  },
  importDutiesWarning: {
    description: 'Warning tooltip for DDP option about import duties and taxes',
    defaultMessage:
      'When selected, you pay all import duties and taxes on behalf of your customer. These will be charged to your account as a post-purchase adjustment.',
    id: 'WqcsVx',
  },
});
